import {useEffect, useState} from "react";

export const useWindowProperty = (propertyName: string, defaultValue: boolean = false, isConfigurable = true) => {
    const [windowPropertyName, setWindowPropertyName] = useState(defaultValue);
    useEffect(() => {
        if (!propertyName) {
            alert(`Свойство ${propertyName} не может быть пустым.`)
            return
        }
        Object.defineProperty(window, propertyName, {
            get(): boolean | undefined {
                if (this[`_${propertyName}`] === undefined) {
                    return defaultValue
                }
                return this[`_${propertyName}`]
            },
            set(isPropertyValue: any) {
                if (!isConfigurable) {
                    alert(`Свойство ${propertyName} изменять нельзя.`)
                    return
                }
                if (typeof isPropertyValue !== 'boolean') {
                    alert(`Свойство ${propertyName} может быть только типа Boolean.`)
                    return
                }
                setWindowPropertyName(isPropertyValue)
                this[`_${propertyName}`] = isPropertyValue
            },
            configurable: true,
        })
        return () => {
            // @ts-ignore
            delete window[`_${propertyName}`]
            // @ts-ignore
            delete window[`_${propertyName}`]
        }
    }, [])

    return windowPropertyName
}
